import { gql } from '@apollo/client';

export const DELETE_INCOME_SOURCE = gql`
  mutation deleteIncomeSource($input: DeleteIncomeSourceInput) {
    deleteIncomeSource(input: $input) {
      commandId
    }
  }
`;
